import React from 'react';
import type { FC } from 'react';
import styled from 'styled-components';
import type { IResortList } from './Models/resort-list.model';

interface Props {
  className?: string;
  lists: IResortList[];
  linkedResortListTitle: string;
}

export const ResortListDesktop: FC<Props> = (props) => {
  const { className, lists, linkedResortListTitle } = props;

  return (
    <StyledResortList className={className}>
      <StyledTitle>{linkedResortListTitle}</StyledTitle>
      <StyledWrapper>
        {lists.map((list) => {
          const { name, elements } = list;
          if (!Array.isArray(elements) || !elements.length) return null;

          return (
            <StyledColumn key={name}>
              <StyledName>{name}</StyledName>
              {elements.map((elem) => (
                <StyledAnchor
                  href={elem.link}
                  onClick={elem.onClick}
                  key={elem.link}
                >
                  {elem.text}
                </StyledAnchor>
              ))}
            </StyledColumn>
          );
        })}
      </StyledWrapper>
    </StyledResortList>
  );
};

const StyledResortList = styled.div`
  width: 100%;
  padding: 16px;
  margin-top: 8px;

  border-radius: 4px;

  background-color: #fff;
`;

const StyledTitle = styled.h2`
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  margin: 0 0 16px;
`;

const StyledName = styled.p`
  color: #4d4d4d;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
`;

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;

  font-size: 16px;
  line-height: 20px;
`;

const StyledAnchor = styled.a`
  text-decoration: none;
  color: #007aff;

  &:not(:first-child) {
    margin-top: 8px;
  }
`;
